import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js'
import { API_GOOGLE_KEY, API_URL } from '..';
import Select from 'react-select'
import swal from 'sweetalert';
import mapboxgl from "mapbox-gl";
import { Spinner, Overlay } from 'react-bootstrap'; // Add these imports
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { useMapbox } from '../GoogleMapsContext';
const options = [
    { value: 'Light Duty Towing', label: 'Light Duty Towing' },
    { value: 'Medium Duty Towing', label: 'Medium Duty Towing' },
    { value: 'Heavy Duty Towing', label: 'Heavy Duty Towing' },
    { value: 'Flatbed Towing', label: 'Flatbed Towing' },
    { value: 'Motorcycle Towing', label: 'Motorcycle Towing' },
    { value: 'Long-Distance Towing', label: 'Long-Distance Towing' },
    { value: 'Emergency Towing', label: 'Emergency Towing' },
    { value: 'Accident Recovery', label: 'Accident Recovery' },
    { value: 'Winch-Out Services', label: 'Winch-Out Services' },
    { value: 'Roadside Assistance', label: 'Roadside Assistance' },
    { value: 'Fuel Delivery', label: 'Fuel Delivery' },
    { value: 'Lockout Services', label: 'Lockout Services' },
    { value: 'Tire Change Services', label: 'Tire Change Services' },
    { value: 'Jump Start Services', label: 'Jump Start Services' },
    { value: 'Impound Towing', label: 'Impound Towing' },
    { value: 'Specialty Vehicle Towing', label: 'Specialty Vehicle Towing' },
    { value: 'Classic Car Towing', label: 'Classic Car Towing' },
    { value: 'Fleet Services', label: 'Fleet Services' },
    { value: 'Commercial Towing', label: 'Commercial Towing' },
    { value: 'Recreational Vehicle Towing', label: 'Recreational Vehicle Towing' },
    ];
    
const CompanyLayer = () => {
    const inputRef = useRef(null)
    const [isLoading,setIsLoading] = useState(false)
    const {mapboxgl} = useMapbox();
    const [statusPricing, setStatusPricing] = useState('monthly')
    const [password, setPassword] = useState({
        currentPassword :'',
        newPassword: ''
    })
    const [uploadedImages, setUploadedImages] = useState([]);
   const autocompleteRef = useRef(null)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [phone,setPhone]= useState("")
    const [selectedPlace, setSelectedPlace] = useState(null);
    
    const [formData,setFormData] = useState({})
    const [showAlertMessage, setshowAlertMessage] = useState({
      status:false,
      message:''
    });
    const [currentUser , setCurrentUser ]  = useState(null) 
    const fetchSingleAffiliate = async()=>{
        setIsLoading(true)
        const user = JSON.parse(localStorage.getItem('user'));
        setCurrentUser(user)
        // fetch-affiliate/:id
        let headersList = {
            "Accept": "*/*",
            "Content-Type": "application/json"
           }
        const response = await fetch(`${API_URL}/api/affiliates/fetch-affiliate/${user.id}`,{
            method:'GET',
            headers:headersList,
        });
        const data = await response.json();
        setFormData(data)
        if(data.services_provided){
            const formatted = data.services_provided.split(',');
            setSelectedOptions(formatted.map((item)=>({value:item,label:item})))
            
        }
        if(data.address && data.map_location){
            const convert = data.map_location.split(',')
            setSelectedPlace({lat:parseFloat(convert[0]), lng:parseFloat(convert[1]), address: data.address})
            setIsMounted(true)
        }
        if(data.business_logo){
            setUploadedImages([
                { src: API_URL+data.business_logo}
            ])
        }
        setPhone(data.phone)
        setIsLoading(false)
    }
    
    useEffect(()=>{
        fetchSingleAffiliate();
    },[1])
    const formatPhoneNumber = (value) => {
        // Remove all non-digit characters
        const cleaned = value.replace(/\D/g, "");
      
        // Format the number as (XXX) XXX-XXXX
        const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      
        if (!match) return value;
      
        const formatted = [
          match[1] && `(${match[1]}`,
          match[2] && `) ${match[2]}`,
          match[3] && `-${match[3]}`,
        ]
          .filter(Boolean)
          .join("");
      
        return formatted;
      };
      const handleInputChange = (e) => {
        const formattedPhone = formatPhoneNumber(e.target.value);
        setPhone(formattedPhone);
      };
  
  
      // fetchSingleAffiliate();
  
    
    const handleChange = (selected) => {
      setSelectedOptions(selected || []);
    };
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map((file) => ({
            src: URL.createObjectURL(file),
            file
        }));
        setUploadedImages(newImages);
        e.target.value = '';
    };

    const removeImage = (src) => {
        setUploadedImages((prev) =>
            prev.filter((image) => image.src !== src)
        );
        URL.revokeObjectURL(src);
    };

    const onFormSubmit = async (event) =>{
        event.preventDefault();
        const file = uploadedImages.map((e)=>e.file);
        console.log(file[0])
        // return false;
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "multipart/form-data"
         }
         const formDatas = new FormData();
         formDatas.append('business_name' , formData.business_name)
         formDatas.append('email' , formData.email)
         formDatas.append('no_of_trucks' , formData.no_of_trucks)
         formDatas.append('address' , selectedPlace.address)
         formDatas.append('map_location' ,selectedPlace.lat +','+selectedPlace.lng)
         formDatas.append('working_area' ,formData.working_area)
         formDatas.append('services_provided' ,selectedOptions.map((e)=>e.value).toString())
         formDatas.append('description' ,formData.description)
         formDatas.append("business_logo",file.length !== 0  ? file[0] :  null)
         
         let response = await fetch(`${API_URL}/api/affiliates/update/${formData.id}`, { 
           method: "POST",
           body: formDatas,
           
         });
         
         let data = await response.json();
         if(response.status == 200){
           swal('Profile Updated', "Your profile is successfully updated", "success");
         }else{
            swal('Server', "Your profile is not updated. Please try again", "error");
         }
         
      }
    //   const onLoad = (autocomplete) => {
    //     autocompleteRef.current = autocomplete;
    //   };
    
    //   const onPlaceChanged = () => {
    //     if (autocompleteRef.current) {
    //       const place = autocompleteRef.current.getPlace();
    //       setSelectedPlace({
    //         name: place.name,
    //         address: place.formatted_address,
    //         lat: place.geometry?.location?.lat(),
    //         lng: place.geometry?.location?.lng(),
    //       });
    //     }
    //   };

      const changePassword = async (event)=>{
            event.preventDefault();
           const apiCall = await fetch(API_URL + `/api/affiliates/change-password/${currentUser.id}/owner` , {method: 'PUT' , body : JSON.stringify(password) , headers:{
            'Content-Type' :'application/json'
           }});
           const response = await apiCall.json();
           if(apiCall.status ===200){
            swal('Password changed', 'Your password is successfully updated', "success");
            setPassword({
                currentPassword: '',
                newPassword:''
            })
           }else{
            swal('Password not changed', `${response.message}`, "error");
           }
      }

      const [isMounted, setIsMounted] = useState(false);
      const incidentGeocoderRef = useRef(null);
      
      useEffect(() => {
        setIsMounted(true);
        return () => {
          setIsMounted(false);
          // Cleanup geocoders when unmounting
          if (incidentGeocoderRef.current) {
            incidentGeocoderRef.current.onRemove();
            incidentGeocoderRef.current = null;
          }
        };
      }, []);
      useEffect(() => {
        if (!isMounted || !mapboxgl.accessToken) return;
      
        const clearContainer = (id) => {
          const container = document.getElementById(id);
          if (container) container.innerHTML = '';
          return container;
        };
      
        const incidentContainer = clearContainer('incident-location-container');
        if (!incidentContainer) return;
      
        // Initialize geocoder with initial value if available
        const  proximity= {
            longitude: selectedPlace?.lng || 0,
            latitude: selectedPlace?.lat || 0
          }
        //   console.log(proximity)
        incidentGeocoderRef.current = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          placeholder: selectedPlace?.address,
          marker: false,
          proximity: {
            longitude: selectedPlace?.lng || 0,
            latitude: selectedPlace?.lat || 0
          }
        });
      
        // Set initial value if available
        if (selectedPlace?.address) {
          const input = incidentContainer.querySelector('input');
          if (input) {
            input.value = selectedPlace.address;
          }
        }
      
        incidentGeocoderRef.current.addTo(incidentContainer);
      
        incidentGeocoderRef.current.on('result', (e) => {
          const { place_name, center } = e.result;
          setSelectedPlace({
            address: place_name,
            lat: center[1],
            lng: center[0],
            name: place_name.split(',')[0]
          });
        });
      
        return () => {
          if (incidentGeocoderRef.current) {
            incidentGeocoderRef.current.onRemove();
          }
        };
      }, [isMounted, selectedPlace?.address]); 
//   if(!isLoaded) return <p>Loading....</p>
    return (
        
          <div className="col-xxl-12">
            
            <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
            {isLoading && (
    <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9000,
        borderRadius: '12px'
    }}>
        <Spinner 
            animation="border" 
            role="status"
            variant="info"
            style={{ width: '3rem', height: '3rem' }}
        >
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
)}
                <div className="card-body p-24 pt-10">
                    <ul
                        className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16"
                        id="pills-tab"
                        role="tablist"
                    >
                    
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10 active"
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                type="button"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected="true"
                            >
                                Profile
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-settings-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-settings"
                                type="button"
                                role="tab"
                                aria-controls="pills-settings"
                                aria-selected="false"
                            >
                                Subscription
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className="nav-link px-16 py-10"
                                id="pills-password-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-password"
                                type="button"
                                role="tab"
                                aria-controls="pills-password"
                                aria-selected="false"
                            >
                                Change Password
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                       
                      
                        <div
                            className="tab-pane fade  show active"
                            id="pills-profile"
                            role="tabpanel"
                            aria-labelledby="pills-profile-tab"
                            tabIndex={0}
                        >
                            <form onSubmit={onFormSubmit}>
                    <div className="row">
                        <div className='col-md-12'>
                        <div className="upload-image-wrapper d-flex align-items-center gap-3 flex-wrap">
                        <div className="uploaded-imgs-container d-flex gap-3 flex-wrap">
                            {uploadedImages.map((image, index) => (
                                <div
                                    key={index}
                                    className="position-relative h-120-px w-200-px border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50"
                                >
                                    <button
                                        type="button"
                                        className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex"
                                        onClick={() => removeImage(image.src)}
                                    >
                                        <Icon icon="radix-icons:cross-2" className="text-xl text-danger-600"></Icon>
                                    </button>
                                    <img
                                        className="w-100 h-100 object-fit-contain"
                                        src={image.src}
                                        alt="Uploaded Preview"
                                    />
                                </div>
                            ))}
                        </div>

                        <label
                            className=" mb-3 upload-file-multiple h-120-px w-200-px border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1"
                            htmlFor="upload-file-multiple"
                        >
                            <Icon icon="solar:camera-outline" className="text-xl text-secondary-light"></Icon>
                            <span className="fw-semibold text-secondary-light">Upload Logo</span>
                            
                            <small>200x120 (.png )</small>
                            <input
                                id="upload-file-multiple"
                                type="file"
                                hidden
                                onChange={handleFileChange}
                            />
                        </label>
                    </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="name"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                    >
                                    Business Name <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control radius-8"
                                    value={formData?.business_name}
                                    onChange={(e)=>setFormData((prev)=>({...prev, business_name: e.target.value}))}
                                    id="name"
                                    placeholder="Enter Full Name"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="email"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Email Address <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="form-control radius-8"
                                    id="email"
                                    value={formData?.email}
                                    onChange={(e)=>setFormData((prev)=>({...prev, email: e.target.value}))}
                                    placeholder="Enter email address"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="number"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    Phone Number
                                </label>
                                <input
                                    type="tel"
                                    value={phone}
                                    onChange={handleInputChange}
                                    
                                    className="form-control radius-8"
                                    id="number"
                                    placeholder="Enter phone number"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="Website"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    {" "}
                                    Address
                                </label>
                                 <div 
                                    id="incident-location-container"
                                    key={`incident-${isMounted}`} // Force re-creation
                                    style={{ minHeight: '50px' }}
                                    />
                                    <input
                                    type="hidden"
                                    name="address"
                                    value={selectedPlace?.address || ''}
                                    required
                                    />
                                {/* <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                                    <input
                                        type="text"
                                        name="address"
                                        className="form-control radius-8"
                                        id="address"
                                        value={selectedPlace?.address}
                                        onChange={(e)=>setSelectedPlace((prev)=>({...prev,address: e.target.value}))}
                                        placeholder="EnterAddress"
                                    />
                                    </Autocomplete> */}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="trucks"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    {" "}
                                    No of Trucks
                                </label>
                                <input
                                    type="number"
                                    className="form-control radius-8"
                                    id="trucks"
                                    value={formData.no_of_trucks}
                                    onChange={(e)=>setFormData((prev)=>({...prev, no_of_trucks : e.target.value}))}
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                      
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="service_provide"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    {" "}
                                    Service You Provide
                                </label>
                                <Select
                                    options={options}
                                        isMulti
                                        value={selectedOptions}
                                    onChange={handleChange}
                                    placeholder="Select Options"
                                />
                            </div>
                        </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="mb-20">
                                <label
                                    htmlFor="Description"

                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    {" "}
                                    Description
                                </label>
                                <textarea
                                    type=""
                                    rows={6}
                                    value={formData.description}
                                    onChange={(e)=>setFormData((prev)=>({...prev, description : e.target.value}))}
                                    className="form-control radius-8"
                                    id="Description"
                                    placeholder="...."
                                />
                            </div>
                        </div>
                        
                   
                       
                       
                     
                        <div className="d-flex align-items-center justify-content-start gap-3 mt-24">

                            <button
                                type="submit"
                                className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                            >
                                Save Change
                            </button>
                        </div>
                    
                </form>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-settings"
                            role="tabpanel"
                            aria-labelledby="pills-settings-tab"
                            tabIndex={0}
                        >
                            <div>
                            <div className='row'>
                                <div className='col-md-12'>

                                    <p>      <Icon icon="mdi:package-variant" className="text-blue-500" width="50" height="50" />
You are currently using free subscription.</p>
                                </div>
                            </div>
                            <div className="card-body p-40">
                            
                <div className="row justify-content-center">
                    <div className="col-xxl-10">
                        <div className="text-center">
                            <h4 className="mb-16">Subscription Pricing</h4>
                            <p className="mb-0 text-lg text-secondary-light">
                               
                            </p>
                        </div>
                        <div className="pricing-tab">
                            <div className="form-switch switch-primary d-flex align-items-center gap-3 mt-40 justify-content-center">
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="yes"
                                >
                                    Monthly
                                </label>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="yes"
                                    onChange={(e)=>{
                                        if(e.target.checked === true) {
                                            setStatusPricing('anually')
                                        }else{
                                            
                                            setStatusPricing('monthly')
                                        }
                                    }}

                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="yes"
                                >
                                    Annually
                                </label>
                            </div>
                        </div>
                        {
                            statusPricing  === 'monthly' ? 
                            <div className="row gy-4">
                            <div className="col-xxl-4 col-sm-6">
                                <div className="pricing-plan position-relative radius-24 overflow-hidden border bg-base">
                                    <div className="d-flex align-items-center gap-16">
                                        <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-primary-50">
                                            <img src="assets/images/pricing/price-icon4.png" alt="" />
                                        </span>
                                        <div className="">
                                            <span className="fw-medium text-md text-secondary-light">
                                                For individuals
                                            </span>
                                            <h6 className="mb-0">Basic</h6>
                                        </div>
                                    </div>
                                    <p className="mt-16 mb-0 text-secondary-light mb-28">
                                        Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                        adipiscing elit.{" "}
                                    </p>
                                    <h3 className="mb-24">
                                        $99{" "}
                                        <span className="fw-medium text-md text-secondary-light">
                                            /monthly
                                        </span>{" "}
                                    </h3>
                                    <span className="mb-20 fw-medium">What’s included</span>
                                    <ul>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                All analytics features
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Up to 250,000 tracked visits
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Normal support
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Up to 3 team members
                                            </span>
                                        </li>
                                    </ul>
                                    <button

                                        className="bg-primary-600 bg-hover-primary-700 text-white text-center border border-primary-600 text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                    >
                                        Get started
                                    </button>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-sm-6">
                                <div className="pricing-plan featured-item position-relative radius-24 overflow-hidden border bg-primary-600 text-white z-1">
                                    <img
                                        src="assets/images/pricing/pricing-shape.png"
                                        alt=""
                                        className="position-absolute end-0 top-10 z-n1"
                                    />
                                    <span className="bg-white bg-opacity-25 text-white radius-24 py-8 px-24 text-sm position-absolute end-0 top-0 z-1 rounded-start-top-0 rounded-end-bottom-0">
                                        Popular
                                    </span>
                                    <div className="d-flex align-items-center gap-16">
                                        <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-base">
                                            <img src="assets/images/pricing/price-icon2.png" alt="" />
                                        </span>
                                        <div className="">
                                            <span className="fw-medium text-md text-white">
                                                For startups
                                            </span>
                                            <h6 className="mb-0 text-white">Pro</h6>
                                        </div>
                                    </div>
                                    <p className="mt-16 mb-0 text-white mb-28">
                                        Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                        adipiscing elit.{" "}
                                    </p>
                                    <h3 className="mb-24 text-white">
                                        $199{" "}
                                        <span className="fw-medium text-md text-white">/monthly</span>{" "}
                                    </h3>
                                    <span className="mb-20 fw-medium">What’s included</span>
                                    <ul>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-lg   "
                                                />
                                            </span>
                                            <span className="text-white text-lg">
                                                All analytics features
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-lg   "
                                                />
                                            </span>
                                            <span className="text-white text-lg">
                                                Up to 250,000 tracked visits
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-lg   "
                                                />
                                            </span>
                                            <span className="text-white text-lg">Normal support</span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-lg   "
                                                />
                                            </span>
                                            <span className="text-white text-lg">
                                                Up to 3 team members
                                            </span>
                                        </li>
                                    </ul>
                                    <button

                                        className="bg-white text-primary-600 text-white text-center border border-white text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                    >
                                        Get started
                                    </button>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-sm-6">
                                <div className="pricing-plan position-relative radius-24 overflow-hidden border bg-base">
                                    <div className="d-flex align-items-center gap-16">
                                        <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-primary-50">
                                            <img src="assets/images/pricing/price-icon5.png" alt="" />
                                        </span>
                                        <div className="">
                                            <span className="fw-medium text-md text-secondary-light">
                                                For big companies
                                            </span>
                                            <h6 className="mb-0">Enterprise</h6>
                                        </div>
                                    </div>
                                    <p className="mt-16 mb-0 text-secondary-light mb-28">
                                        Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                        adipiscing elit.{" "}
                                    </p>
                                    <h3 className="mb-24">
                                        $399{" "}
                                        <span className="fw-medium text-md text-secondary-light">
                                            /monthly
                                        </span>{" "}
                                    </h3>
                                    <span className="mb-20 fw-medium">What’s included</span>
                                    <ul>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                All analytics features
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Up to 250,000 tracked visits
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16 mb-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Normal support
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-center gap-16">
                                            <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                                <Icon
                                                    icon="iconamoon:check-light"
                                                    className="text-white text-lg "
                                                />
                                            </span>
                                            <span className="text-secondary-light text-lg">
                                                Up to 3 team members
                                            </span>
                                        </li>
                                    </ul>
                                    <button

                                        className="bg-primary-600 bg-hover-primary-700 text-white text-center border border-primary-600 text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                    >
                                        Get started
                                    </button>
                                </div>
                            </div>
                        </div> :
                         <div className="row gy-4">
                         <div className="col-xxl-4 col-sm-6">
                             <div className="pricing-plan position-relative radius-24 overflow-hidden border bg-base">
                                 <div className="d-flex align-items-center gap-16">
                                     <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-primary-50">
                                         <img src="assets/images/pricing/price-icon4.png" alt="" />
                                     </span>
                                     <div className="">
                                         <span className="fw-medium text-md text-secondary-light">
                                             For individuals
                                         </span>
                                         <h6 className="mb-0">Basic</h6>
                                     </div>
                                 </div>
                                 <p className="mt-16 mb-0 text-secondary-light mb-28">
                                     Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                     adipiscing elit.{" "}
                                 </p>
                                 <h3 className="mb-24">
                                     $99{" "}
                                     <span className="fw-medium text-md text-secondary-light">
                                         /year
                                     </span>{" "}
                                 </h3>
                                 <span className="mb-20 fw-medium">What’s included</span>
                                 <ul>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             All analytics features
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Up to 250,000 tracked visits
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Normal support
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Up to 3 team members
                                         </span>
                                     </li>
                                 </ul>
                                 <button

                                     className="bg-primary-600 bg-hover-primary-700 text-white text-center border border-primary-600 text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                 >
                                     Get started
                                 </button>
                             </div>
                         </div>
                         <div className="col-xxl-4 col-sm-6">
                             <div className="pricing-plan featured-item position-relative radius-24 overflow-hidden border bg-primary-600 text-white z-1">
                                 <img
                                     src="assets/images/pricing/pricing-shape.png"
                                     alt=""
                                     className="position-absolute end-0 top-10 z-n1"
                                 />
                                 <span className="bg-white bg-opacity-25 text-white radius-24 py-8 px-24 text-sm position-absolute end-0 top-0 z-1 rounded-start-top-0 rounded-end-bottom-0">
                                     Popular
                                 </span>
                                 <div className="d-flex align-items-center gap-16">
                                     <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-base">
                                         <img src="assets/images/pricing/price-icon2.png" alt="" />
                                     </span>
                                     <div className="">
                                         <span className="fw-medium text-md text-white">
                                             For startups
                                         </span>
                                         <h6 className="mb-0 text-white">Pro</h6>
                                     </div>
                                 </div>
                                 <p className="mt-16 mb-0 text-white mb-28">
                                     Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                     adipiscing elit.{" "}
                                 </p>
                                 <h3 className="mb-24 text-white">
                                     $199{" "}
                                     <span className="fw-medium text-md text-white">/year</span>{" "}
                                 </h3>
                                 <span className="mb-20 fw-medium">What’s included</span>
                                 <ul>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-lg   "
                                             />
                                         </span>
                                         <span className="text-white text-lg">
                                             All analytics features
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-lg   "
                                             />
                                         </span>
                                         <span className="text-white text-lg">
                                             Up to 250,000 tracked visits
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-lg   "
                                             />
                                         </span>
                                         <span className="text-white text-lg">Normal support</span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-white rounded-circle text-primary-600">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-lg   "
                                             />
                                         </span>
                                         <span className="text-white text-lg">
                                             Up to 3 team members
                                         </span>
                                     </li>
                                 </ul>
                                 <button

                                     className="bg-white text-primary-600 text-white text-center border border-white text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                 >
                                     Get started
                                 </button>
                             </div>
                         </div>
                         <div className="col-xxl-4 col-sm-6">
                             <div className="pricing-plan position-relative radius-24 overflow-hidden border bg-base">
                                 <div className="d-flex align-items-center gap-16">
                                     <span className="w-72-px h-72-px d-flex justify-content-center align-items-center radius-16 bg-primary-50">
                                         <img src="assets/images/pricing/price-icon5.png" alt="" />
                                     </span>
                                     <div className="">
                                         <span className="fw-medium text-md text-secondary-light">
                                             For big companies
                                         </span>
                                         <h6 className="mb-0">Enterprise</h6>
                                     </div>
                                 </div>
                                 <p className="mt-16 mb-0 text-secondary-light mb-28">
                                     Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                                     adipiscing elit.{" "}
                                 </p>
                                 <h3 className="mb-24">
                                     $399{" "}
                                     <span className="fw-medium text-md text-secondary-light">
                                         /year
                                     </span>{" "}
                                 </h3>
                                 <span className="mb-20 fw-medium">What’s included</span>
                                 <ul>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             All analytics features
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Up to 250,000 tracked visits
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16 mb-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Normal support
                                         </span>
                                     </li>
                                     <li className="d-flex align-items-center gap-16">
                                         <span className="w-24-px h-24-px d-flex justify-content-center align-items-center bg-primary-600 rounded-circle">
                                             <Icon
                                                 icon="iconamoon:check-light"
                                                 className="text-white text-lg "
                                             />
                                         </span>
                                         <span className="text-secondary-light text-lg">
                                             Up to 3 team members Yearly
                                         </span>
                                     </li>
                                 </ul>
                                 <button

                                     className="bg-primary-600 bg-hover-primary-700 text-white text-center border border-primary-600 text-sm btn-sm px-12 py-10 w-100 radius-8 mt-28"

                                 >
                                     Get started
                                 </button>
                             </div>
                         </div>
                     </div>
                        }
                      
                    </div>
                </div>
            </div>
                            </div>
                        </div>
                        <div
                            className="tab-pane fade"
                            id="pills-password"
                            role="tabpanel"
                            aria-labelledby="pills-password-tab"
                            tabIndex={0}
                        >
                            <form onSubmit={changePassword}>
                    <div className="row">
                        
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="password"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                    >
                                    Current Password <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="password"
                                    value={password.currentPassword}
                                    onChange={(e)=>setPassword((prev)=>({...prev, currentPassword:  e.target.value}))}
                                    required
                                    className="form-control radius-8"
                                    id="password"
                                    placeholder="*********"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="mb-20">
                                <label
                                    htmlFor="newpassword"
                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                >
                                    New Password <span className="text-danger-600">*</span>
                                </label>
                                <input
                                    type="password"
                                    value={password.newPassword}
                                    onChange={(e)=>setPassword((prev)=>({...prev, newPassword:  e.target.value}))}
                                    required
                                    className="form-control radius-8"
                                    id="newpassword"
                                    placeholder="*********"
                                />
                            </div>
                        </div>
                      
                      
                  
                       
                       
                     
                        <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                           
                            <button
                                type="submit"
                                className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                            >
                                Change Password
                            </button>
                        </div>
                    </div>
                </form>
                        </div>
                    </div>
                </div>
            </div>
         </div>
   

    );
};

export default CompanyLayer;